import * as React from 'react';
import styled, { keyframes, withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { StyledTableRow } from '../../Product/ProductTabRowTable';
import { prop, ZemplinLoaderWrapper } from '../../../..';
import { TableWrapper } from '../../General/TableWrapper';
import { FlexRow } from '../../../Defaults/Flexbox/Flexbox';
import { TableTh, TableTd } from '../../General/Table';
import { ModalItemsTabRow } from './ModalItemsTabRow';
import { ModalItemMobile } from './ModalItemMobile';
import { WholePackagesOnly } from '../Items/WholePackageOnlyInfoText';
import {
  getPackagesString,
  resolveIsVykurovaciaOrPletiva,
} from '../../selectors';
import { ModalMobileValue } from './ModalMobileValue';

interface Props {
  products: any;
  isFetching: boolean;
  theme: any;
  refreshCart: () => void;
  count: string;
  handleCountChange: any;
  isLoggedIn: boolean;
  isFromCategory?: boolean;
  isRequest?: boolean;
  noHandlingFee?: boolean;
  isQuickBuy?: boolean;
}

function ModalItemsTable({
  products,
  isFetching,
  theme,
  count,
  isLoggedIn,
  handleCountChange,
  isFromCategory,
  isRequest,
  noHandlingFee,
  isQuickBuy,
}: Props) {
  const totalPriceText = isLoggedIn ? __('bez DPH') : __('s DPH');

  const COLUMNS = [
    { name: `Cena ${totalPriceText}`, align: 'right' },
    { name: 'Množstvo', align: 'center' },
    { name: 'Balenie' },
    { name: `Spolu ${totalPriceText}` },
  ];

  const productsComponent =
    products &&
    products.map((p: any, i) => {
      return (
        <React.Fragment key={p.product_id}>
          <StyledTableRow>
            <ModalItemsTabRow
              isRequest={isRequest}
              count={count}
              handleCountChange={handleCountChange}
              product={p}
              isLoggedIn={isLoggedIn}
              isFromCategory={isFromCategory}
              noHandlingFee={noHandlingFee}
            />
          </StyledTableRow>
        </React.Fragment>
      );
    });

  const mobileProductsComponent =
    products &&
    products.map((p: any, i) => (
      <ModalItemMobile
        isRequest={isRequest}
        count={count}
        handleCountChange={handleCountChange}
        key={p.product_id}
        product={p}
        isLoggedIn={isLoggedIn}
        isFromCategory={isFromCategory}
        noHandlingFee={noHandlingFee}
      />
    ));

  const headers =
    COLUMNS &&
    COLUMNS.map((item: any, i) => (
      <StyledTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={i}
      >
        {item.name}
      </StyledTableTh>
    ));

  const productQuickBuy =
    isQuickBuy && products.length === 1 ? prop(products, '0') : null;
  const boxQuantity = prop(
    productQuickBuy,
    'product_detail.main_good.box_quantity',
  );
  const isVykurovaciaOrPletiva = resolveIsVykurovaciaOrPletiva(
    prop(productQuickBuy, 'product_detail'),
  );
  const unit = prop(productQuickBuy, 'product_detail.main_good.units');
  return (
    <Wrapper>
      <DesktopListProductsWrapper>
        {isQuickBuy && !!boxQuantity && (
          <ModalMobileValue
            title={
              isVykurovaciaOrPletiva
                ? __('Množstvo v balení')
                : __('Množstvo v kartóne')
            }
            value={getPackagesString(boxQuantity, unit)}
          />
        )}
        <TableWrapper
          noItemsText={__('Nenašli sa produkty')}
          headers={headers}
          rows={productsComponent}
        />
      </DesktopListProductsWrapper>
      <MobileListProductsWrapper>
        {mobileProductsComponent}
      </MobileListProductsWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;

  ${({ theme }) => theme.mediab.m810`
     margin-bottom: 0;
  `}
`;

const DesktopListProductsWrapper = styled.div`
  display: block;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const MobileListProductsWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      display: flex;
      justify-content: center;
      flex-flow: column;
  `}
`;

const StyledTableTh = styled(TableTh)`
  padding-bottom: ${rem(24)};
`;

const WithTheme: any = withTheme(ModalItemsTable);
export { WithTheme as ModalItemsTable };
